import React, { FC } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import Box from '@o2/ui/Box';
import InfoMessage from '@o2/common-business/InfoMessage';
import Button from '@o2/ui/Button';
import Container from '@o2/ui/Container';
import Typography from '@o2/ui/Typography';
import { useTranslation } from 'react-i18next';
import useCodeLists from '@hooks/useCodeLists';

const ConfirmAutomaticPayment: FC = ({ ...props }) => {
  const { t } = useTranslation();
  const { getItems } = useCodeLists();
  const [ link ] = getItems('continueAutomaticSuccess');
  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints['down']('sm'));

  return (
    <Container maxWidth="md">
      <Box my={4}>
        <Box mb={3}>
          <InfoMessage
            variant="success"
            title={
              <Typography data-elm="1.3.2.3.1-001" variant="h5" component="span">
                {t('topup.automaticPayment.thankYou')}
              </Typography>
            }
            description={
              <Typography data-elm="1.3.2.3.1-002" variant="body1">
                {t('topup.automaticPayment.inFewMinutes')}
              </Typography>
            }
            {...props}
          />
        </Box>
        <Button 
          data-elm="1.3.2.3.1-003"
          fullWidth={smDown}
          size="small"
          color="primary"
          variant="text"
          onClick={() => window.location.href = link}
        >
          {t('topup.automaticPayment.continue')}
        </Button>
      </Box>
    </Container>
  );
};

export default ConfirmAutomaticPayment;
